import React from "react";
import { Table } from "react-bootstrap";

export const DashboardCurrentCourses = ({ courses }) => {
  const currentlyRunningCourase = courses.filter((item) => {
    if (item.endDate) {
      return new Date(item.endDate) > Date.now();
    }
  });
  console.log(currentlyRunningCourase);
  return (
    <div>
      <h3>Current Ongoing class</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Course</th>
            <th>Start</th>
            <th>Class</th>
            <th>Location</th>
            {/* <th># of Students</th> */}
          </tr>
        </thead>
        <tbody>
          {currentlyRunningCourase.map(
            (
              {
                _id,
                title,
                location,
                endDate,
                commenceDate,
                courseCode,
                classSession,
              },
              i
            ) => (
              <tr>
                <td>{i + 1}</td>
                <td>
                  {title} <br />
                  Code: {courseCode}
                </td>
                <td>
                  Start: {new Date(commenceDate).toLocaleDateString()}
                  <br />
                  End: {new Date(endDate).toLocaleDateString()}
                </td>
                <td>{classSession}</td>
                <td>{location}</td>
              </tr>
            )
          )}
        </tbody>
      </Table>
    </div>
  );
};
